export default __webpack_public_path__ + "static/cornerincrease-37a8d991a0d7413b4d01001e190b77ea.png";